import { SubscriberPackageKey } from 'library/ts/model/user/SubscriberPackageKey';
import { SubscriberPackageValue } from 'library/ts/model/user/SubscriberPackageValue';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
export class UserModel extends AbstractTagClass {
    constructor(argument) {
        super({
            ...argument,
            name: 'UserModel'
        });
        this.#validate(argument?.paramsUser);
        this.#initSubscriberStatuses(argument?.paramsUser?.userStatus);
        this.#initBundleStatuses(argument?.paramsUser?.bundleStatus);
        this.#userId = argument?.paramsUser?.userId;
        this.#pinGate = argument?.paramsUser?.pinGate;
        this.#mvpdId = argument?.paramsUser?.mvpdId;
    }
    #validSubscriberKeys = {
        esb: false,
        ssb: false,
        sb: true,
        tsb: true,
        tve: true
    };
    #subscriberStatuses;
    #initSubscriberStatuses = (userStatusStr) => {
        if (this.utils.Type.isEmptyString(userStatusStr) || !this.utils.Type.isString(userStatusStr)) {
            this.#subscriberStatuses = [];
            return;
        }
        this.#subscriberStatuses = userStatusStr.split(',')
            .map((status) => status.trim())
            .map((status) => {
            if (status === SubscriberPackageKey.ANON) {
                return {
                    key: SubscriberPackageKey.SB,
                    value: SubscriberPackageValue.VALUE_0
                };
            }
            if (status !== SubscriberPackageKey.ANON) {
                const sections = status.split('|');
                return {
                    key: sections[0].trim().toLowerCase(),
                    value: sections[1].trim()
                };
            }
        });
    };
    get subscriberStatuses() {
        return this.#subscriberStatuses;
    }
    getValidStatuses = () => this.subscriberStatuses.filter((status) => this.#validSubscriberKeys[status.key] === true);
    getInvalidStatuses = () => this.subscriberStatuses.filter((status) => this.#validSubscriberKeys[status.key] === false);
    getCurrentValidStatus = () => this.getValidStatuses()[0];
    #bundleStatuses;
    #initBundleStatuses = (bundleStatusStr) => {
        if (this.utils.Type.isEmpty(bundleStatusStr) || !this.utils.Type.isString(bundleStatusStr)) {
            this.#bundleStatuses = [];
            return;
        }
        this.#bundleStatuses = bundleStatusStr.split(',').map((status) => status.trim());
    };
    get bundleStatuses() {
        return this.#bundleStatuses;
    }
    #userId;
    get userId() {
        return this.#userId;
    }
    #pinGate;
    get pinGate() {
        return this.#pinGate;
    }
    #mvpdId;
    get mvpdId() {
        return this.#mvpdId;
    }
    #validate = (params) => {
        if (this.utils.Type.isEmpty(params))
            throw new Error('params are missing/invalid.');
        if (this.utils.Type.isEmpty(params.userStatus) || !this.utils.Type.isString(params.userStatus))
            throw new Error('userStatus is missing/invalid.');
    };
}
